module.exports = new __parcel__URL__("whiplash.056f4428.jpg").toString();